<template>
  <el-container>

    <!-- 头部板块 -->
    <el-header>
      <div class="header-nnszrzztext-box"></div>

      <div class="header-zwfwtext-box"></div>

      <div class="header-date-box">
        <span>{{nowdate}}</span>
      </div>
    </el-header>
    
    <!-- 头部导航栏 -->
    <div>
      <ul class="topnav">
        <li>
          <a href="http://zrzyj.nanning.gov.cn" target="_blank" rel="noopener noreferrer">
            <img src="../../assets/HomePage.png">
            <span>网站首页</span>
          </a>
        </li>

        <li>
          <a href="http://zrzyj.nanning.gov.cn/bjgk/" target="_blank" rel="noopener noreferrer">
            <img src="../../assets/Overview.png">
            <span>本局概况</span>
          </a>
        </li>

        <li>
          <a href="http://zrzyj.nanning.gov.cn/zwgk_57/zcfg/" target="_blank" rel="noopener noreferrer">
            <img src="../../assets/GovernmentInformation.png">
            <span>政府信息公开</span>
          </a>
        </li>

        <li>
          <a href="http://nn.zwfw.gxzf.gov.cn/gxzwfw/bmft/bmftList.do?deptCode=11450100007575907U&webId=10" target="_blank" rel="noopener noreferrer">
            <img src="../../assets/WebsiteServices.png">
            <span>网上办事</span>
          </a>
        </li>

        <li>
          <a href="http://zrzyj.nanning.gov.cn/bsfw_57/" target="_blank" rel="noopener noreferrer">
            <img src="../../assets/Exchange.png">
            <span>办事服务</span>
          </a>
        </li>

      </ul>
    </div>

    <el-container>
      <!-- 左栏板块 -->
      <el-aside>

        <!-- 左栏面包屑(主界面不显示) -->
        <div 
          class="left-breadcrumb-box"
          v-if="left_show_cmpt!='main'" >
          <el-breadcrumb class="left-breadcrumb" separator-class="el-icon-arrow-right">
            <el-breadcrumb-item><a @click="change_left_cmpt('main')">首页</a></el-breadcrumb-item>
            <el-breadcrumb-item><a>{{ breadcrumb_2level_addr[left_show_cmpt] }}</a></el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <!-- 主菜单栏组件 -->
        <left_main_list v-if="left_show_cmpt=='main'" @change_left_cmpt="change_left_cmpt"></left_main_list>
        <!-- 界面切换组件demo (示例用)-->
        <left_cmpt_demo v-if="left_show_cmpt=='left_cmpt_demo'"></left_cmpt_demo>
        <!-- 2023年度“招拍挂”公开出让计划切换组件 -->
        <left_crjh_list v-if="left_show_cmpt=='left_crjh_list'"></left_crjh_list>
        <!-- 自然资源局分局切换组件 -->
        <left_zrzyjfj_list v-if="left_show_cmpt=='left_zrzyjfj_list'"></left_zrzyjfj_list>
        <!-- 不动产受理点切换组件 -->
        <left_bdcsld_list v-if="left_show_cmpt=='left_bdcsld_list'"></left_bdcsld_list>

      </el-aside>

      <!-- 地图板块 -->
      <el-main>
        <iframe src="https://www.nnrig.com/special_map/generalMap.html" seamless frameborder ></iframe>
      </el-main>
    </el-container>

  </el-container>
</template>

<script>
  import zwfwmap from "./zwfwmap_pc";
  export default zwfwmap;

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

a {
  color: #42b983;
}

.el-container{
  overflow: hidden;
}
/* 头部板块 */
.el-header{
  position:relative;
  background-color: #4a88d9;
  color: #333;
  text-align: center;
  height: 130px !important;
  line-height: 150px;
  background-image: url('../../assets/TopBackground.jpg');
  background-size:100% 100%;
  background-repeat:no-repeat;
  background-position:center; 
}

/* 左侧板块 */
.el-aside {
  overflow: hidden;
  background-color: #D3DCE6;
  color: #333;
  text-align: center;
  width: 330px !important;
  height: 100% !important;
  line-height: 200px;
  background-image: url('../../assets/LeftBackground.jpg');
  background-size:100% 100%;
  background-repeat:no-repeat;
  background-position:center; 
}

/* 地图板块 */
.el-main {
  width: 100%;
  height: 100%;
  background-color: #E9EEF3;
  color: #333;
  text-align: center;
  padding: 0;
  margin: 0;
  border: 0;
}
.el-main iframe{
  width: 100%;
  height: 100%;

}
.el-main::-webkit-scrollbar{
  display:none;
}
.el-container {
  height: 100%;
}

/* 头部南宁市自然资源局字体图片容器*/
.header-nnszrzztext-box{
  position:absolute;
  top: 8px;
  left: 80px;
  width: 230px;
  height: 50px;
  background-image: url('../../assets/header_nnszrzyj.png');
  background-size:100% 100%;
  background-repeat:no-repeat;
  background-position:center; 
}

/* 头部日期文本容器*/
.header-date-box{
  position:absolute;
  text-align: left;
  line-height: 20px;
  top: 60px;
  right: 50px;
  width: 170px;
  height: 20px;
  font-size: 15px;
  color: rgb(255, 255, 255);
}

/* 头部政务服务地图字体图片容器*/
.header-zwfwtext-box{
  position:absolute;
  width: 420px;
  height: 70px;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background-image: url('../../assets/header_zwfwdt.png');
  background-size:100% 100%;
  background-repeat:no-repeat;
  background-position:center; 
}

/* 导航条 */
.topnav {
  overflow: hidden;
  background-color: rgb(255, 255, 255);
  position: relative;
  text-align: center;
  height: 50px;
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.topnav li{
  display: inline-block;
  vertical-align: middle;
  margin-left: 45px;
  margin-top: 15px;
}
 
/* 导航链接 */
.topnav a {
  height: 25px;
  display: inline-block;
  font-weight:bold;
  top: 0;
  left: 0;
  font-size: 20px;
  color: black;
  text-decoration :none;
}

/* 导航链接图片 */
.topnav img{
  vertical-align: middle;
  display: inline;
  zoom: 0.7;
  margin-top: -0.26042vw;
  height: 35px;
}

/* 左栏面包屑 */
.left-breadcrumb-box{
  width: 100%;
  height: 40px;
  padding: 0;
  margin: 0;
  border: 0;
  float:left;
  vertical-align: middle;
}
.left-breadcrumb{
  margin-left: 40px;
  line-height: 40px;
  font-size: 15px;
}
.left-breadcrumb a{
  color: #000000;
}
.left-breadcrumb a:hover{
  color: #409EFF;
}

</style>



// WEBPACK FOOTER //
// src/components/zwfwmap-pc/zwfwmap_pc.vue